<table class="call-log-details__table">
  <tbody>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.date" | Translate }}</b>
      </th>
      <td *ngIf="callItem.timestamp; else empty">{{ callItem.timestamp | date: dateFormat.long }}</td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.phone-number" | Translate }}</b>
      </th>
      <td
        *ngIf="callItem.number; else empty"
        colspan="2">
        {{ callItem.number }}
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.from" | Translate }}</b>
      </th>
      <td *ngIf="callItem.from; else empty">
        <div class="details-container">
          {{ callItem.fromFull || callItem.from }}
          <a
            [href]="callItem.callLinks.from | sanitizeNumberLink"
            class="call-log-details__body-icon">
            <i class="icon-small-handset-outline"></i>
          </a>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.to" | Translate }}</b>
      </th>
      <td *ngIf="callItem.to; else empty">
        <div class="details-container">
          {{ callItem.toFull || callItem.to }}
          <a
            [href]="callItem.callLinks.to | sanitizeNumberLink"
            class="call-log-details__body-icon">
            <i class="icon-small-handset-outline"></i>
          </a>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.crm" | Translate }}</b>
      </th>
      <td
        colspan="2"
        *ngIf="callItem.contactCrm && callItem.contactCrmUrl; else empty">
        <a
          [href]="callItem.contactCrmUrl | sanitizeUrl"
          target="_blank">
          <img
            class="company-call-history-common-list-item-crm"
            [src]="callItem.contactCrmIconLink" />
        </a>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.type" | Translate }}</b>
      </th>
      <td *ngIf="callItem.type; else empty">
        <ng-container
          [ngTemplateOutlet]="type"
          [ngTemplateOutletContext]="{
            type: callItem.type
          }"></ng-container>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.answerer" | Translate }}</b>
      </th>
      <td *ngIf="callItem.answerer; else empty">
        <div class="details-container">
          {{ callItem.answererFull || callItem.answerer }}
          <a
            [href]="callItem.callLinks.answerer | sanitizeNumberLink"
            class="call-log-details__body-icon">
            <i class="icon-small-handset-outline"></i>
          </a>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.direction" | Translate }}</b>
      </th>
      <td *ngIf="callItem.direction; else empty">
        <ng-container
          [ngTemplateOutlet]="dir"
          [ngTemplateOutletContext]="{
            direction: callItem.direction
          }">
        </ng-container>
      </td>
    </tr>
    <tr>
      <th>
        <b>{{ "events.company-call-history.details.table.duration" | Translate }}</b>
      </th>
      <td *ngIf="callItem.duration !== null || callItem.duration !== undefined; else empty">
        <ng-template
          [ngTemplateOutlet]="dur"
          [ngTemplateOutletContext]="{
            duration: callItem.duration
          }"></ng-template>
      </td>
    </tr>
    <tr *ngIf="callItem.ruleNames?.length > 0">
      <th>
        <b>{{ "events.company-call-history.details.table.rules" | Translate }}</b>
      </th>
      <td>
        <ng-template
          [ngTemplateOutlet]="rules"
          [ngTemplateOutletContext]="{
            rules: callItem.ruleNames
          }"></ng-template>
      </td>
    </tr>
    <tr *ngIf="callItem.labels?.length > 0">
      <th>{{ "events.company-call-history.details.table.labels" | Translate }}</th>
      <td>
        <ng-template
          [ngTemplateOutlet]="labels"
          [ngTemplateOutletContext]="{
            labels: callItem.labels
          }"></ng-template>
      </td>
    </tr>
  </tbody>
</table>

<!-- TEMPLATES -->
<ng-template #empty>
  <td>-</td>
</ng-template>

<ng-template
  #dir
  let-direction="direction">
  <i
    *ngIf="direction === PhoneCallDirections.OUTBOUND"
    class="mr-1 icon-small-call-outbound vox-text-bright-crimson"></i>
  <i
    *ngIf="direction === PhoneCallDirections.INBOUND"
    class="mr-1 icon-small-call-inbound vox-text-royal-blue"></i>
  <i
    *ngIf="direction === PhoneCallDirections.INTERNAL"
    class="mr-1 icon-small-call-instruction vox-text-aquamarine"></i>
  <span>{{ "events.company-call-history.details.fields.direction." + direction | Translate }}</span>
</ng-template>

<ng-template
  #dur
  let-duration="duration">
  <ng-container *ngIf="!isNumber(duration)">
    {{ "events.company-call-history.details.fields.duration." + duration | Translate }}
  </ng-container>
  <ng-container *ngIf="isNumber(duration)">
    {{ duration | secondstominutes }}
  </ng-container>
</ng-template>

<ng-template
  #type
  let-type="type">
  <app-call-type-chip [type]="type"></app-call-type-chip>
</ng-template>

<ng-template
  #rules
  let-rules="rules">
  <ng-container *ngFor="let rule of rules; let last = last">
    <span class="vox-chip vox-chip_royal-blue-text">
      {{ rule }}
    </span>
    <i
      class="icon-small-arrow-right"
      *ngIf="!last"></i>
  </ng-container>
</ng-template>

<ng-template
  #labels
  let-labels="labels">
  <ng-container *ngFor="let label of labels; let last = last">
    <span class="vox-chip vox-chip_royal-blue-text">
      {{ label }}
    </span>
    <i
      class="icon-small-arrow-right"
      *ngIf="!last"></i>
  </ng-container>
</ng-template>
